import * as T from './actionTypes';

const INIT_STATE = {
  // cross-flow list
  list: [],
  listLoading: false,
  listError: null,
  listPagination: null,

  // current selected records
  currentDesc: null,
  currentDescLoading: false,
  currentDescError: null,

  currentAsc: null,
  currentAscLoading: false,
  currentAscError: null,

  // activity feed
  activity: [],
  activityLoading: false,
  activityError: null,

  // mutation flags
  saving: false,
  saveError: null,
  saveSuccess: null,
};

const Materiovigilance = (state = INIT_STATE, action) => {
  switch (action.type) {
    // ---- list -----------------------------------------------------------
    case T.FETCH_MATERIO_LIST:
      return { ...state, listLoading: true, listError: null };
    case T.FETCH_MATERIO_LIST_SUCCESS:
      return {
        ...state, listLoading: false,
        list: action.payload.content || action.payload || [],
        listPagination: action.payload.content ? {
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          number: action.payload.number,
          size: action.payload.size,
        } : null,
      };
    case T.FETCH_MATERIO_LIST_FAIL:
      return { ...state, listLoading: false, listError: action.payload };

    // ---- DESCENDING current --------------------------------------------
    case T.FETCH_DESC:
      return { ...state, currentDescLoading: true, currentDescError: null };
    case T.FETCH_DESC_SUCCESS:
      return { ...state, currentDescLoading: false, currentDesc: action.payload };
    case T.FETCH_DESC_FAIL:
      return { ...state, currentDescLoading: false, currentDescError: action.payload };

    case T.CREATE_DESC:
    case T.UPDATE_DESC:
    case T.DELETE_DESC:
    case T.CHANGE_STATUS_DESC:
    case T.ADD_DESC_ATTACHMENT:
    case T.REMOVE_DESC_ATTACHMENT:
      return { ...state, saving: true, saveError: null, saveSuccess: null };

    case T.CREATE_DESC_SUCCESS:
      return { ...state, saving: false, saveSuccess: 'created', currentDesc: action.payload };
    case T.UPDATE_DESC_SUCCESS:
    case T.CHANGE_STATUS_DESC_SUCCESS:
      return { ...state, saving: false, saveSuccess: 'updated', currentDesc: action.payload };
    case T.DELETE_DESC_SUCCESS:
      return {
        ...state, saving: false, saveSuccess: 'deleted',
        list: state.list.filter(r => !(r.flowKind === 'DESCENDING' && r.id === action.payload)),
      };
    case T.ADD_DESC_ATTACHMENT_SUCCESS:
      return {
        ...state, saving: false, saveSuccess: 'attachment_added',
        currentDesc: state.currentDesc
          ? { ...state.currentDesc, attachments: [action.payload, ...(state.currentDesc.attachments || [])] }
          : state.currentDesc,
      };
    case T.REMOVE_DESC_ATTACHMENT_SUCCESS:
      return {
        ...state, saving: false, saveSuccess: 'attachment_removed',
        currentDesc: state.currentDesc
          ? { ...state.currentDesc, attachments: (state.currentDesc.attachments || []).filter(a => a.id !== action.payload) }
          : state.currentDesc,
      };

    case T.CREATE_DESC_FAIL:
    case T.UPDATE_DESC_FAIL:
    case T.DELETE_DESC_FAIL:
    case T.CHANGE_STATUS_DESC_FAIL:
    case T.ADD_DESC_ATTACHMENT_FAIL:
    case T.REMOVE_DESC_ATTACHMENT_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // ---- ASCENDING current ---------------------------------------------
    case T.FETCH_ASC:
      return { ...state, currentAscLoading: true, currentAscError: null };
    case T.FETCH_ASC_SUCCESS:
      return { ...state, currentAscLoading: false, currentAsc: action.payload };
    case T.FETCH_ASC_FAIL:
      return { ...state, currentAscLoading: false, currentAscError: action.payload };

    case T.CREATE_ASC:
    case T.UPDATE_ASC:
    case T.DELETE_ASC:
    case T.CHANGE_STATUS_ASC:
      return { ...state, saving: true, saveError: null, saveSuccess: null };

    case T.CREATE_ASC_SUCCESS:
      return { ...state, saving: false, saveSuccess: 'created', currentAsc: action.payload };
    case T.UPDATE_ASC_SUCCESS:
    case T.CHANGE_STATUS_ASC_SUCCESS:
      return { ...state, saving: false, saveSuccess: 'updated', currentAsc: action.payload };
    case T.DELETE_ASC_SUCCESS:
      return {
        ...state, saving: false, saveSuccess: 'deleted',
        list: state.list.filter(r => !(r.flowKind === 'ASCENDING' && r.id === action.payload)),
      };

    case T.CREATE_ASC_FAIL:
    case T.UPDATE_ASC_FAIL:
    case T.DELETE_ASC_FAIL:
    case T.CHANGE_STATUS_ASC_FAIL:
      return { ...state, saving: false, saveError: action.payload };

    // ---- activity ------------------------------------------------------
    case T.FETCH_MATERIO_ACTIVITY:
      return { ...state, activityLoading: true, activityError: null };
    case T.FETCH_MATERIO_ACTIVITY_SUCCESS:
      return { ...state, activityLoading: false, activity: action.payload || [] };
    case T.FETCH_MATERIO_ACTIVITY_FAIL:
      return { ...state, activityLoading: false, activityError: action.payload };

    // ---- clear ---------------------------------------------------------
    case T.CLEAR_MATERIO_MESSAGES:
      return { ...state, saveError: null, saveSuccess: null };

    default:
      return state;
  }
};

export default Materiovigilance;
